import { render, staticRenderFns } from "./PersonalLoanBankSelection.vue?vue&type=template&id=23e13fcc"
import script from "./PersonalLoanBankSelection.vue?vue&type=script&lang=js"
export * from "./PersonalLoanBankSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports